import { Field } from 'react-final-form';
import { Button, TextInput } from '@tokens-studio/ui';
import { Box, Flex, Label } from '../../shared/components';

interface ResetPasswordFormProps {
  onSubmit: () => void;
  loading: boolean;
}

export default function ResetPasswordForm({ onSubmit, loading }: ResetPasswordFormProps): JSX.Element {
  return (
    <form
      onSubmit={onSubmit}
      style={{
        width: '100%',
      }}
    >
      <Flex
        css={{
          flexDirection: 'column',
          width: '100%',
        }}
      >
        <Box
          css={{
            marginBottom: '$5',
            width: '100%',
          }}
        >
          <Field name="password">
            {(inputProps) => (
              <>
                <Box
                  css={{
                    marginBottom: '$3',
                  }}
                >
                  <Label htmlFor="password-input">New password</Label>
                </Box>
                <TextInput
                  placeholder="Enter your new password"
                  type="password"
                  {...inputProps.input}
                  id="password-input"
                  required
                />
              </>
            )}
          </Field>
        </Box>
        <Box css={{ width: '100%' }}>
          <Button variant="primary" type="submit" loading={loading}>
            Submit
          </Button>
        </Box>
      </Flex>
    </form>
  );
}
